import notificationBar from '../utils/notification-bar';

export default function location() {
	const options = {
		title: 'We have redirected you based on your IP address. If this is incorrect, please use the language dropdown within the header',
		error: false,
		important: false,
		flag: true,
	};
	let currentCode;
	let loggedIn = false;
	const body = document.querySelector('body');
	const currentSwitcher = document.querySelector('.site-switcher__current');
	const switcher = document.querySelector('.site-switcher');
	const switcherItems = document.querySelectorAll('.site-switcher__item');

	// Check if user is logged in
	document.addEventListener('DOMContentLoaded', () => {
		if (
			body instanceof window.HTMLElement &&
			body.classList.contains('logged-in')
		) {
			loggedIn = true;
		}
	});

	// Get the notification translation
	document.addEventListener('DOMContentLoaded', () => {
		if (currentSwitcher instanceof window.HTMLElement) {
			options.title = currentSwitcher.getAttribute('data-message');
		}
	});

	// Check localstorage for a redirect
	document.addEventListener('DOMContentLoaded', () => {
		const redirect = localStorage.getItem('redirect') ?? 'false';
		if (redirect === 'true') {
			// Show notification bar with options
			notificationBar(options);
			localStorage.setItem('redirect', 'false');
		}
	});

	// This function is responsible for the language dropdown
	const handleLanguageDropdown = () => {
		if (currentSwitcher instanceof window.HTMLElement) {
			// Toggle language dropdown on current switcher click
			currentSwitcher.addEventListener('click', () => {
				switcher.classList.toggle('site-switcher__open');
			});
		}

		switcherItems.forEach((item) => {
			item.addEventListener('click', () => {
				// Handle language selection and redirect
				window.location.href = item.getAttribute('data-URL');
				localStorage.setItem(
					'location',
					item.getAttribute('data-country')
				);
				switcher.classList.toggle('site-switcher__open');
			});
		});
	};

	// This function is responsible for getting the user's location
	const getUserLocation = () => {
		if (loggedIn === false) {
			if (currentSwitcher instanceof window.HTMLElement) {
				currentCode = currentSwitcher.getAttribute('data-country');
				options.title = currentSwitcher.getAttribute('data-message');
			}

			const location = localStorage.getItem('location') ?? 'false';

			// If local storage has a location saved
			if (location !== 'false' && location !== currentCode) {
				const redirect = document.querySelector(
					`[data-country="${location}"]`
				);
				if (redirect instanceof HTMLElement) {
					const redirectURL = redirect.getAttribute('data-URL');

					if (redirectURL.length) {
						// Set redirect flag and navigate to the selected location
						localStorage.setItem('redirect', 'true');
						window.location.href = redirectURL;
					}
				}
			}
			// If local storage doesn't have a location saved
			if (location === 'false') {
				// Fetch user's location data from an API
				fetch('//api.db-ip.com/v2/free/self')
					.then((response) => response.json())
					.then((data) => {
						const code = data.countryCode.toLowerCase();
						const redirect = document.querySelector(
							`[data-country="${code}"]`
						);
						if (code && redirect && code !== currentCode) {
							// Save location and set redirect flag
							localStorage.setItem('location', code);
							localStorage.setItem('redirect', 'true');
							window.location.href =
								redirect.getAttribute('data-URL');
						}
					})
					.catch((error) => {
						console.log('Error: ' + error);
						localStorage.setItem('location', currentCode);
					});
			}
		}
	};

	// Initialize the location-related functionality
	handleLanguageDropdown();
	// getUserLocation();
}
